import { Container, Title } from "./CommonFindContent";

export const NoContent = () => (
  <Container>
    <Title>No Content</Title>
    <p>Try adjusting your search params above.</p>
  </Container>
);
